import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelRadio as _vModelRadio, withDirectives as _withDirectives, vModelText as _vModelText } from "vue"

const _hoisted_1 = { class: "card border-0 rounded-3 mb-4 bg-white shadow-sm" }
const _hoisted_2 = { class: "card-header bg-light-subtle d-flex justify-content-between align-items-center py-3 px-4" }
const _hoisted_3 = { class: "d-flex align-items-center gap-2" }
const _hoisted_4 = { class: "d-inline-flex align-items-center gap-1 bg-secondary-subtle text-secondary px-3 py-1 rounded-2 fs-12" }
const _hoisted_5 = { class: "card-body p-4" }
const _hoisted_6 = { class: "row g-3 mb-4" }
const _hoisted_7 = { class: "col-md-4" }
const _hoisted_8 = { class: "p-3 border rounded-3 h-100 bg-light-subtle d-flex flex-column justify-content-between" }
const _hoisted_9 = ["title"]
const _hoisted_10 = {
  key: 1,
  class: "text-muted fs-12 mb-2 italic"
}
const _hoisted_11 = { class: "mt-2 pt-2 border-top d-flex gap-2" }
const _hoisted_12 = ["href"]
const _hoisted_13 = { class: "btn btn-xs btn-primary btn-sm fs-11 mb-0 cursor-pointer" }
const _hoisted_14 = ["disabled"]
const _hoisted_15 = { class: "col-md-4" }
const _hoisted_16 = { class: "p-3 border rounded-3 h-100 bg-light-subtle d-flex flex-column justify-content-between" }
const _hoisted_17 = { class: "d-flex align-items-center justify-content-between mb-2" }
const _hoisted_18 = {
  key: 0,
  class: "badge bg-danger-subtle text-danger fs-11"
}
const _hoisted_19 = {
  key: 0,
  class: "mb-2",
  style: {"max-height":"180px","overflow-y":"auto"}
}
const _hoisted_20 = ["title"]
const _hoisted_21 = { class: "fs-12 text-dark text-truncate" }
const _hoisted_22 = { class: "d-flex align-items-center gap-1 flex-shrink-0" }
const _hoisted_23 = ["href"]
const _hoisted_24 = ["onClick"]
const _hoisted_25 = {
  key: 1,
  class: "text-muted fs-12 mb-2 italic"
}
const _hoisted_26 = { class: "mt-2 pt-2 border-top d-flex gap-2" }
const _hoisted_27 = { class: "btn btn-xs btn-danger btn-sm fs-11 mb-0 cursor-pointer d-inline-flex align-items-center gap-1" }
const _hoisted_28 = {
  key: 0,
  class: "spinner-border spinner-border-sm"
}
const _hoisted_29 = ["disabled"]
const _hoisted_30 = { class: "col-md-4" }
const _hoisted_31 = { class: "p-3 border rounded-3 h-100 bg-light-subtle d-flex flex-column justify-content-between" }
const _hoisted_32 = { class: "d-flex align-items-center justify-content-between mb-2" }
const _hoisted_33 = {
  key: 0,
  class: "badge bg-success-subtle text-success fs-11"
}
const _hoisted_34 = {
  key: 1,
  class: "badge bg-secondary-subtle text-secondary fs-11"
}
const _hoisted_35 = {
  key: 0,
  class: "text-muted fs-12 mb-2"
}
const _hoisted_36 = {
  key: 1,
  class: "text-muted fs-12 mb-2"
}
const _hoisted_37 = {
  key: 0,
  class: "mb-2",
  style: {"max-height":"220px","overflow-y":"auto"}
}
const _hoisted_38 = { class: "d-flex align-items-center justify-content-between mb-1" }
const _hoisted_39 = { class: "fw-bold fs-12 text-dark text-truncate me-1" }
const _hoisted_40 = { class: "fs-11 text-muted text-truncate mb-2" }
const _hoisted_41 = { class: "d-flex align-items-center gap-2" }
const _hoisted_42 = ["href"]
const _hoisted_43 = ["onClick", "disabled"]
const _hoisted_44 = {
  key: 0,
  class: "spinner-border spinner-border-sm"
}
const _hoisted_45 = {
  key: 1,
  class: "mb-2"
}
const _hoisted_46 = ["title"]
const _hoisted_47 = {
  key: 2,
  class: "text-muted fs-12 mb-2 italic"
}
const _hoisted_48 = {
  key: 3,
  class: "p-3 border rounded bg-light text-muted fs-12 d-flex align-items-center gap-2"
}
const _hoisted_49 = {
  key: 0,
  class: "mt-2 pt-2 border-top d-flex gap-2 flex-wrap"
}
const _hoisted_50 = ["href"]
const _hoisted_51 = ["disabled"]
const _hoisted_52 = {
  key: 0,
  class: "spinner-border spinner-border-sm"
}
const _hoisted_53 = { class: "p-3 rounded-3 bg-light border mb-4" }
const _hoisted_54 = { class: "d-flex justify-content-between align-items-center flex-wrap gap-2 mb-3" }
const _hoisted_55 = { class: "text-muted fs-12 d-flex align-items-center flex-wrap gap-2" }
const _hoisted_56 = ["disabled"]
const _hoisted_57 = { class: "p-2 mb-3 bg-white rounded border" }
const _hoisted_58 = { class: "d-flex gap-4" }
const _hoisted_59 = { class: "form-check" }
const _hoisted_60 = { class: "form-check" }
const _hoisted_61 = { class: "row g-3 mb-3" }
const _hoisted_62 = { class: "col-md-8" }
const _hoisted_63 = { class: "col-md-4" }
const _hoisted_64 = {
  key: 0,
  class: "text-primary fs-11 mt-1"
}
const _hoisted_65 = {
  key: 0,
  class: "alert alert-warning py-2 px-3 fs-12 mb-3 rounded-2 d-flex justify-content-between align-items-center flex-wrap gap-2"
}
const _hoisted_66 = { class: "d-flex align-items-center gap-2" }
const _hoisted_67 = { class: "text-dark" }
const _hoisted_68 = ["disabled"]
const _hoisted_69 = { class: "pt-2 border-top" }
const _hoisted_70 = {
  key: 0,
  class: "d-flex justify-content-end align-items-center gap-2 mb-2 fs-11 text-muted"
}
const _hoisted_71 = { class: "material-symbols-outlined fs-14" }
const _hoisted_72 = { class: "material-symbols-outlined fs-14" }
const _hoisted_73 = { class: "d-flex justify-content-end align-items-center flex-wrap gap-2" }
const _hoisted_74 = ["disabled"]
const _hoisted_75 = ["disabled", "title"]
const _hoisted_76 = ["disabled", "title"]
const _hoisted_77 = {
  key: 0,
  class: "p-3 rounded-3 bg-warning-subtle border border-warning mb-4"
}
const _hoisted_78 = { class: "row g-2 mb-2" }
const _hoisted_79 = { class: "col-md-8" }
const _hoisted_80 = { class: "col-md-4" }
const _hoisted_81 = { class: "d-flex justify-content-end" }
const _hoisted_82 = ["disabled"]
const _hoisted_83 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-1"
}
const _hoisted_84 = { class: "border rounded-3 overflow-hidden" }
const _hoisted_85 = { class: "bg-light-subtle py-2 px-3 border-bottom d-flex justify-content-between align-items-center" }
const _hoisted_86 = { class: "badge bg-secondary-subtle text-secondary fs-11" }
const _hoisted_87 = { class: "table-responsive" }
const _hoisted_88 = { class: "table table-hover align-middle mb-0 fs-13" }
const _hoisted_89 = { class: "text-muted text-nowrap fs-12" }
const _hoisted_90 = { class: "fs-12 text-dark fw-medium mt-1" }
const _hoisted_91 = { class: "fs-11 text-muted" }
const _hoisted_92 = { class: "text-break fs-12 text-dark" }
const _hoisted_93 = {
  key: 0,
  class: "d-flex flex-column gap-1"
}
const _hoisted_94 = ["href", "title"]
const _hoisted_95 = { class: "text-truncate" }
const _hoisted_96 = ["onClick", "disabled"]
const _hoisted_97 = {
  key: 1,
  class: "text-muted fs-12"
}
const _hoisted_98 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[17] || (_cache[17] = _createElementVNode("div", { class: "d-flex align-items-center gap-2" }, [
        _createElementVNode("span", { class: "material-symbols-outlined text-success fs-22" }, "verified_user"),
        _createElementVNode("h5", { class: "mb-0 fs-15 fw-bold text-dark" }, "Deliverables Resmi & Quality Control (QC)")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", {
          class: _normalizeClass(["badge px-3 py-2 fs-12", _ctx.qcStatusBadgeClass(_ctx.order.qc_status)])
        }, " QC: " + _toDisplayString(_ctx.order.qc_status || 'PENDING'), 3),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", null, "Run " + _toDisplayString(_ctx.order.current_revision_run || 1) + " / " + _toDisplayString(_ctx.order.max_revision_runs || 1), 1),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-xs btn-link p-0 text-primary text-decoration-none d-flex align-items-center ms-1",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openEditMaxRunsPrompt && _ctx.openEditMaxRunsPrompt(...args))),
            title: "Ubah Kuota Batas Maksimal Revisi Pelanggan"
          }, _cache[16] || (_cache[16] = [
            _createElementVNode("span", { class: "material-symbols-outlined fs-15" }, "edit", -1)
          ]))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _cache[61] || (_cache[61] = _createElementVNode("h6", { class: "fs-14 fw-bold text-dark mb-3" }, "3 Berkas Luaran Resmi (Deliverables) Sesuai SOP RBN", -1)),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", null, [
              _cache[19] || (_cache[19] = _createElementVNode("div", { class: "d-flex align-items-center gap-2 mb-2" }, [
                _createElementVNode("span", { class: "material-symbols-outlined text-primary fs-20" }, "description"),
                _createElementVNode("span", { class: "fw-bold fs-13 text-dark" }, "1. Naskah Hasil (.docx)")
              ], -1)),
              _cache[20] || (_cache[20] = _createElementVNode("p", { class: "text-muted fs-12 mb-2" }, "Naskah hasil perbaikan / parafrase final.", -1)),
              (_ctx.order.final_manuscript_docx)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "text-success fs-12 fw-medium text-truncate mb-2",
                    title: _ctx.getFilename(_ctx.order.final_manuscript_docx)
                  }, [
                    _cache[18] || (_cache[18] = _createElementVNode("span", { class: "material-symbols-outlined fs-14 align-middle" }, "check_circle", -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.getFilename(_ctx.order.final_manuscript_docx)), 1)
                  ], 8, _hoisted_9))
                : (_openBlock(), _createElementBlock("div", _hoisted_10, "Belum diunggah"))
            ]),
            _createElementVNode("div", _hoisted_11, [
              (_ctx.order.final_manuscript_docx)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    href: _ctx.getFileUrl(_ctx.order.final_manuscript_docx),
                    target: "_blank",
                    class: "btn btn-xs btn-outline-primary btn-sm fs-11"
                  }, " Unduh ", 8, _hoisted_12))
                : _createCommentVNode("", true),
              _createElementVNode("label", _hoisted_13, [
                _cache[21] || (_cache[21] = _createTextVNode(" Unggah DOCX ")),
                _createElementVNode("input", {
                  type: "file",
                  class: "d-none",
                  accept: ".docx,.doc",
                  onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.uploadDocx && _ctx.uploadDocx(...args))),
                  disabled: _ctx.uploadingDocx
                }, null, 40, _hoisted_14)
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_17, [
                _cache[22] || (_cache[22] = _createElementVNode("div", { class: "d-flex align-items-center gap-2" }, [
                  _createElementVNode("span", { class: "material-symbols-outlined text-danger fs-20" }, "picture_as_pdf"),
                  _createElementVNode("span", { class: "fw-bold fs-13 text-dark" }, "2. Laporan Asli Software (.pdf)")
                ], -1)),
                (_ctx.vendorPdfList.length > 0)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(_ctx.vendorPdfList.length) + " File ", 1))
                  : _createCommentVNode("", true)
              ]),
              _cache[26] || (_cache[26] = _createElementVNode("p", { class: "text-muted fs-12 mb-2" }, "Laporan asli Turnitin, Grammarly, AI detector, dll.", -1)),
              (_ctx.vendorPdfList.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.vendorPdfList, (file, idx) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: idx,
                        class: "d-flex align-items-center justify-content-between py-1 px-2 border rounded bg-white mb-1 shadow-xs"
                      }, [
                        _createElementVNode("div", {
                          class: "d-flex align-items-center gap-1 text-truncate me-2",
                          title: file.name || _ctx.getFilename(file.path)
                        }, [
                          _cache[23] || (_cache[23] = _createElementVNode("span", { class: "material-symbols-outlined text-danger fs-16 flex-shrink-0" }, "description", -1)),
                          _createElementVNode("span", _hoisted_21, _toDisplayString(file.name || _ctx.getFilename(file.path)), 1)
                        ], 8, _hoisted_20),
                        _createElementVNode("div", _hoisted_22, [
                          _createElementVNode("a", {
                            href: _ctx.getFileUrl(file.path),
                            target: "_blank",
                            class: "btn btn-xs btn-outline-danger p-1 lh-1",
                            title: "Buka / Unduh PDF"
                          }, _cache[24] || (_cache[24] = [
                            _createElementVNode("span", { class: "material-symbols-outlined fs-14" }, "open_in_new", -1)
                          ]), 8, _hoisted_23),
                          _createElementVNode("button", {
                            type: "button",
                            onClick: ($event: any) => (_ctx.deleteVendorPdf(idx)),
                            class: "btn btn-xs btn-outline-secondary p-1 lh-1 text-danger",
                            title: "Hapus PDF"
                          }, _cache[25] || (_cache[25] = [
                            _createElementVNode("span", { class: "material-symbols-outlined fs-14" }, "delete", -1)
                          ]), 8, _hoisted_24)
                        ])
                      ]))
                    }), 128))
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_25, "Belum diunggah"))
            ]),
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("label", _hoisted_27, [
                (_ctx.uploadingPdf)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_28))
                  : _createCommentVNode("", true),
                _cache[27] || (_cache[27] = _createElementVNode("span", { class: "material-symbols-outlined fs-14" }, "upload_file", -1)),
                _createElementVNode("span", null, _toDisplayString(_ctx.vendorPdfList.length > 0 ? '+ Tambah PDF' : 'Unggah PDF Asli'), 1),
                _createElementVNode("input", {
                  type: "file",
                  class: "d-none",
                  accept: ".pdf",
                  multiple: "",
                  onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.uploadVendorPdfs && _ctx.uploadVendorPdfs(...args))),
                  disabled: _ctx.uploadingPdf
                }, null, 40, _hoisted_29)
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_30, [
          _createElementVNode("div", _hoisted_31, [
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_32, [
                _cache[28] || (_cache[28] = _createElementVNode("div", { class: "d-flex align-items-center gap-2" }, [
                  _createElementVNode("span", { class: "material-symbols-outlined text-success fs-20" }, "verified"),
                  _createElementVNode("span", { class: "fw-bold fs-13 text-dark" }, "3. Protokol Resmi RBN A4")
                ], -1)),
                (_ctx.protocolsList.length > 0)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_33, _toDisplayString(_ctx.protocolsList.length) + " Protokol ", 1))
                  : (!_ctx.isProtocolRequired)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_34, " Tidak Ada Protokol "))
                    : _createCommentVNode("", true)
              ]),
              (_ctx.isProtocolRequired)
                ? (_openBlock(), _createElementBlock("p", _hoisted_35, "Sertifikat protokol ber-QR Code resmi auto-generate."))
                : (_openBlock(), _createElementBlock("p", _hoisted_36, "Layanan/paket ini tidak mewajibkan sertifikat protokol SOP.")),
              (_ctx.isProtocolRequired)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    (_ctx.protocolsList.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.protocolsList, (proto, idx) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: idx,
                              class: "p-2 border rounded bg-white mb-2 shadow-xs"
                            }, [
                              _createElementVNode("div", _hoisted_38, [
                                _createElementVNode("span", _hoisted_39, _toDisplayString(proto.service_title || proto.protocol_type), 1),
                                _createElementVNode("span", {
                                  class: _normalizeClass(["badge", proto.status === 'VALID' ? 'bg-success-subtle text-success' : 'bg-danger-subtle text-danger']),
                                  style: {"font-size":"10px"}
                                }, _toDisplayString(proto.status), 3)
                              ]),
                              _createElementVNode("div", _hoisted_40, [
                                _cache[29] || (_cache[29] = _createTextVNode(" No: ")),
                                _createElementVNode("strong", null, _toDisplayString(proto.protocol_number || '-'), 1)
                              ]),
                              _createElementVNode("div", _hoisted_41, [
                                (proto.pdf_path)
                                  ? (_openBlock(), _createElementBlock("a", {
                                      key: 0,
                                      href: _ctx.getFileUrl(proto.pdf_path),
                                      target: "_blank",
                                      class: "btn btn-xs btn-success btn-sm fs-11 py-1 px-2 d-inline-flex align-items-center gap-1"
                                    }, _cache[30] || (_cache[30] = [
                                      _createElementVNode("span", { class: "material-symbols-outlined fs-13" }, "open_in_new", -1),
                                      _createElementVNode("span", null, "Buka", -1)
                                    ]), 8, _hoisted_42))
                                  : _createCommentVNode("", true),
                                _createElementVNode("button", {
                                  onClick: ($event: any) => (_ctx.generateSpecificProtocolPdf(proto.protocol_type)),
                                  disabled: _ctx.generatingProto === proto.protocol_type || _ctx.generating,
                                  class: "btn btn-xs btn-outline-success btn-sm fs-11 py-1 px-2 d-inline-flex align-items-center gap-1"
                                }, [
                                  (_ctx.generatingProto === proto.protocol_type)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_44))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("span", null, _toDisplayString(proto.pdf_path ? 'Regenerate' : 'Generate'), 1)
                                ], 8, _hoisted_43)
                              ])
                            ]))
                          }), 128))
                        ]))
                      : (_ctx.order.generated_protocol_pdf)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                            _createElementVNode("div", {
                              class: "text-success fs-12 fw-medium text-truncate mb-2",
                              title: _ctx.getFilename(_ctx.order.generated_protocol_pdf)
                            }, [
                              _cache[31] || (_cache[31] = _createElementVNode("span", { class: "material-symbols-outlined fs-14 align-middle" }, "check_circle", -1)),
                              _createTextVNode(" " + _toDisplayString(_ctx.getFilename(_ctx.order.generated_protocol_pdf)), 1)
                            ], 8, _hoisted_46)
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_47, "Otomatis saat simpan form protokol"))
                  ], 64))
                : (_openBlock(), _createElementBlock("div", _hoisted_48, _cache[32] || (_cache[32] = [
                    _createElementVNode("span", { class: "material-symbols-outlined fs-18 text-secondary" }, "info", -1),
                    _createElementVNode("span", null, "Tidak ada lembar protokol resmi untuk jenis layanan/paket ini.", -1)
                  ])))
            ]),
            (_ctx.isProtocolRequired)
              ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                  (_ctx.protocolsList.length === 0 && _ctx.order.generated_protocol_pdf)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        href: _ctx.getFileUrl(_ctx.order.generated_protocol_pdf),
                        target: "_blank",
                        class: "btn btn-xs btn-success btn-sm fs-11"
                      }, " Buka Dokumen ", 8, _hoisted_50))
                    : _createCommentVNode("", true),
                  _createElementVNode("button", {
                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.generateAllProtocolsPdf && _ctx.generateAllProtocolsPdf(...args))),
                    disabled: _ctx.generating,
                    class: "btn btn-xs btn-outline-success btn-sm fs-11 d-inline-flex align-items-center gap-1"
                  }, [
                    (_ctx.generating)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_52))
                      : _createCommentVNode("", true),
                    _cache[33] || (_cache[33] = _createElementVNode("span", { class: "material-symbols-outlined fs-13" }, "refresh", -1)),
                    _createElementVNode("span", null, _toDisplayString(_ctx.protocolsList.length > 1 ? 'Generate Semua' : 'Generate PDF'), 1)
                  ], 8, _hoisted_51)
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_53, [
        _createElementVNode("div", _hoisted_54, [
          _cache[36] || (_cache[36] = _createElementVNode("h6", { class: "fs-13 fw-bold text-dark mb-0 d-flex align-items-center gap-2" }, [
            _createElementVNode("span", { class: "material-symbols-outlined text-primary fs-18" }, "rule"),
            _createElementVNode("span", null, "Evaluasi & Keputusan Quality Control (QC)")
          ], -1)),
          _createElementVNode("div", _hoisted_55, [
            _createElementVNode("span", null, [
              _cache[34] || (_cache[34] = _createTextVNode(" Status Izin Revisi Pelanggan: ")),
              _createElementVNode("strong", {
                class: _normalizeClass(_ctx.order.revision_allowed ? 'text-success' : 'text-danger')
              }, _toDisplayString(_ctx.order.revision_allowed ? 'DIBUKA' : 'DITUTUP'), 3),
              _createTextVNode(" (Tersisa " + _toDisplayString(Math.max(0, (_ctx.order.max_revision_runs || 1) - (_ctx.order.current_revision_run || 1))) + " kesempatan dari total " + _toDisplayString(_ctx.order.max_revision_runs || 1) + " Run) ", 1)
            ]),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-xs btn-outline-primary py-0 px-2 fs-11 d-inline-flex align-items-center gap-1",
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.addRevisionRunQuota && _ctx.addRevisionRunQuota(...args))),
              disabled: _ctx.updatingQc,
              title: "Tambah kuota batas revisi pelanggan sebanyak 1 run"
            }, _cache[35] || (_cache[35] = [
              _createElementVNode("span", { class: "material-symbols-outlined fs-14" }, "add_circle", -1),
              _createElementVNode("span", null, "Buka Limit (+1 Run)", -1)
            ]), 8, _hoisted_56)
          ])
        ]),
        _createElementVNode("div", _hoisted_57, [
          _cache[39] || (_cache[39] = _createElementVNode("label", { class: "form-label fs-12 fw-semibold text-secondary mb-1" }, "Tujuan Evaluasi QC:", -1)),
          _createElementVNode("div", _hoisted_58, [
            _createElementVNode("div", _hoisted_59, [
              _withDirectives(_createElementVNode("input", {
                class: "form-check-input",
                type: "radio",
                name: "qcTarget",
                id: "targetEditor",
                value: "editor",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.qcTarget) = $event))
              }, null, 512), [
                [_vModelRadio, _ctx.qcTarget]
              ]),
              _cache[37] || (_cache[37] = _createElementVNode("label", {
                class: "form-check-label fs-13 text-dark cursor-pointer",
                for: "targetEditor"
              }, [
                _createElementVNode("strong", null, "Ke Editor"),
                _createTextVNode(),
                _createElementVNode("span", { class: "text-muted" }, "(Internal - perbaikan pengerjaan/protokol)")
              ], -1))
            ]),
            _createElementVNode("div", _hoisted_60, [
              _withDirectives(_createElementVNode("input", {
                class: "form-check-input",
                type: "radio",
                name: "qcTarget",
                id: "targetPelanggan",
                value: "pelanggan",
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.qcTarget) = $event))
              }, null, 512), [
                [_vModelRadio, _ctx.qcTarget]
              ]),
              _cache[38] || (_cache[38] = _createElementVNode("label", {
                class: "form-check-label fs-13 text-dark cursor-pointer",
                for: "targetPelanggan"
              }, [
                _createElementVNode("strong", null, "Ke Pelanggan"),
                _createTextVNode(),
                _createElementVNode("span", { class: "text-muted" }, "(Eksternal - kembalikan untuk revisi / tanggapan)")
              ], -1))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_61, [
          _createElementVNode("div", _hoisted_62, [
            _cache[40] || (_cache[40] = _createElementVNode("label", { class: "form-label fs-12 fw-semibold text-secondary" }, "Catatan Evaluasi / Instruksi QC", -1)),
            _withDirectives(_createElementVNode("textarea", {
              class: "form-control form-control-sm fs-13",
              rows: "3",
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.qcNotes) = $event)),
              placeholder: "Tuliskan catatan hasil review QC untuk editor atau instruksi perbaikan untuk pelanggan..."
            }, null, 512), [
              [_vModelText, _ctx.qcNotes]
            ])
          ]),
          _createElementVNode("div", _hoisted_63, [
            _cache[41] || (_cache[41] = _createElementVNode("label", { class: "form-label fs-12 fw-semibold text-secondary" }, "Lampiran Berkas QC (Opsional)", -1)),
            _createElementVNode("input", {
              type: "file",
              class: "form-control form-control-sm fs-12",
              onChange: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.onQcAttachmentChange && _ctx.onQcAttachmentChange(...args)))
            }, null, 32),
            (_ctx.qcAttachment)
              ? (_openBlock(), _createElementBlock("div", _hoisted_64, " File terpilih: " + _toDisplayString(_ctx.qcAttachment.name), 1))
              : _createCommentVNode("", true),
            _cache[42] || (_cache[42] = _createElementVNode("small", { class: "text-muted fs-11 d-block mt-1" }, "Sertakan berkas markup, anotasi review, atau referensi jika ada.", -1))
          ])
        ]),
        (_ctx.qcTarget === 'pelanggan' && (_ctx.order.current_revision_run || 1) >= (_ctx.order.max_revision_runs || 1))
          ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
              _createElementVNode("div", _hoisted_66, [
                _cache[43] || (_cache[43] = _createElementVNode("span", { class: "material-symbols-outlined text-warning-emphasis fs-18" }, "lock_clock", -1)),
                _createElementVNode("span", _hoisted_67, "Batas kuota revisi pelanggan telah mencapai batas maksimum (" + _toDisplayString(_ctx.order.current_revision_run || 1) + " dari " + _toDisplayString(_ctx.order.max_revision_runs || 1) + " Run). Ingin membuka limit revisi tambahan untuk pelanggan?", 1)
              ]),
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-sm btn-primary py-1 px-3 fs-12 d-inline-flex align-items-center gap-1",
                onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.addRevisionRunQuota && _ctx.addRevisionRunQuota(...args))),
                disabled: _ctx.updatingQc
              }, _cache[44] || (_cache[44] = [
                _createElementVNode("span", { class: "material-symbols-outlined fs-16" }, "add_circle", -1),
                _createElementVNode("span", null, "Buka Limit (+1 Run Revisi)", -1)
              ]), 8, _hoisted_68)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_69, [
          (!_ctx.canApproveQc)
            ? (_openBlock(), _createElementBlock("div", _hoisted_70, [
                _cache[48] || (_cache[48] = _createElementVNode("span", { class: "fw-medium text-secondary" }, "Syarat Approve QC:", -1)),
                _createElementVNode("span", {
                  class: _normalizeClass([_ctx.hasResultDocument ? 'text-success fw-medium' : 'text-danger', "d-inline-flex align-items-center gap-1"])
                }, [
                  _createElementVNode("span", _hoisted_71, _toDisplayString(_ctx.hasResultDocument ? 'check_circle' : 'cancel'), 1),
                  _cache[45] || (_cache[45] = _createElementVNode("span", null, "1 Dokumen Hasil", -1))
                ], 2),
                (_ctx.isProtocolRequired)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _cache[47] || (_cache[47] = _createElementVNode("span", null, "•", -1)),
                      _createElementVNode("span", {
                        class: _normalizeClass([_ctx.hasGeneratedProtocol ? 'text-success fw-medium' : 'text-danger', "d-inline-flex align-items-center gap-1"])
                      }, [
                        _createElementVNode("span", _hoisted_72, _toDisplayString(_ctx.hasGeneratedProtocol ? 'check_circle' : 'cancel'), 1),
                        _cache[46] || (_cache[46] = _createElementVNode("span", null, "Generate Protokol", -1))
                      ], 2)
                    ], 64))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_73, [
            (_ctx.qcTarget === 'editor')
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.updateQc('RETURN_TO_EDITOR', false, undefined, 'editor', 'QC'))),
                  disabled: _ctx.updatingQc,
                  class: "btn btn-sm btn-outline-warning d-flex align-items-center gap-1"
                }, _cache[49] || (_cache[49] = [
                  _createElementVNode("span", { class: "material-symbols-outlined fs-16" }, "undo", -1),
                  _createElementVNode("span", null, "Kembalikan ke Editor", -1)
                ]), 8, _hoisted_74))
              : _createCommentVNode("", true),
            (_ctx.qcTarget === 'pelanggan')
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.updateQc('REVISE_BY_USER', true, undefined, 'pelanggan', 'QC'))),
                  disabled: _ctx.updatingQc || (_ctx.order.current_revision_run || 1) >= (_ctx.order.max_revision_runs || 1),
                  class: "btn btn-sm btn-outline-danger d-flex align-items-center gap-1",
                  title: (_ctx.order.current_revision_run || 1) >= (_ctx.order.max_revision_runs || 1) ? 'Batas maksimal kuota revisi pelanggan telah tercapai' : ''
                }, _cache[50] || (_cache[50] = [
                  _createElementVNode("span", { class: "material-symbols-outlined fs-16" }, "undo", -1),
                  _createElementVNode("span", null, "Kembalikan ke Pelanggan", -1)
                ]), 8, _hoisted_75))
              : _createCommentVNode("", true),
            _createElementVNode("button", {
              onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.updateQc('APPROVED', false, 'Completed', 'editor', 'QC'))),
              disabled: _ctx.updatingQc || !_ctx.canApproveQc,
              class: "btn btn-sm btn-success d-flex align-items-center gap-1",
              title: !_ctx.canApproveQc ? (_ctx.isProtocolRequired ? 'Lengkapi minimal 1 dokumen hasil dan generate protokol untuk Approve QC' : 'Unggah minimal 1 dokumen hasil untuk Approve QC') : 'Approve QC dan Selesaikan Pesanan'
            }, _cache[51] || (_cache[51] = [
              _createElementVNode("span", { class: "material-symbols-outlined fs-16" }, "check_circle", -1),
              _createElementVNode("span", null, "Approve QC & Selesaikan Pesanan", -1)
            ]), 8, _hoisted_76)
          ])
        ])
      ]),
      (_ctx.order.qc_status === 'RETURN_TO_EDITOR')
        ? (_openBlock(), _createElementBlock("div", _hoisted_77, [
            _cache[54] || (_cache[54] = _createElementVNode("div", { class: "d-flex align-items-center gap-2 mb-2" }, [
              _createElementVNode("span", { class: "material-symbols-outlined text-warning-emphasis fs-20" }, "assignment_return"),
              _createElementVNode("h6", { class: "fs-13 fw-bold text-warning-emphasis mb-0" }, "Tanggapan Editor ke QC (Perbaikan Naskah / Protokol Selesai)")
            ], -1)),
            _cache[55] || (_cache[55] = _createElementVNode("p", { class: "fs-12 text-muted mb-2" }, " Pesanan ini dikembalikan oleh QC untuk dilakukan perbaikan. Setelah selesai memperbarui protokol atau naskah, silakan kirimkan tanggapan di bawah ini untuk diajukan kembali ke QC. (Menyimpan protokol di tab bawah juga akan otomatis mencatat tanggapan editor). ", -1)),
            _createElementVNode("div", _hoisted_78, [
              _createElementVNode("div", _hoisted_79, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control form-control-sm fs-13",
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.editorReplyNotes) = $event)),
                  placeholder: "Tuliskan keterangan perbaikan yang telah dilakukan..."
                }, null, 512), [
                  [_vModelText, _ctx.editorReplyNotes]
                ])
              ]),
              _createElementVNode("div", _hoisted_80, [
                _createElementVNode("input", {
                  type: "file",
                  class: "form-control form-control-sm fs-12",
                  onChange: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.onEditorAttachmentChange && _ctx.onEditorAttachmentChange(...args)))
                }, null, 32)
              ])
            ]),
            _createElementVNode("div", _hoisted_81, [
              _createElementVNode("button", {
                onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.submitEditorReply && _ctx.submitEditorReply(...args))),
                disabled: _ctx.replyingQc,
                class: "btn btn-sm btn-warning d-flex align-items-center gap-1 text-dark fw-medium"
              }, [
                (_ctx.replyingQc)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_83))
                  : _createCommentVNode("", true),
                _cache[52] || (_cache[52] = _createElementVNode("span", { class: "material-symbols-outlined fs-16" }, "send", -1)),
                _cache[53] || (_cache[53] = _createElementVNode("span", null, "Kirim Tanggapan & Ajukan Kembali ke QC", -1))
              ], 8, _hoisted_82)
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_84, [
        _createElementVNode("div", _hoisted_85, [
          _cache[56] || (_cache[56] = _createElementVNode("div", { class: "d-flex align-items-center gap-2" }, [
            _createElementVNode("span", { class: "material-symbols-outlined text-secondary fs-18" }, "history"),
            _createElementVNode("span", { class: "fw-bold fs-13 text-dark" }, "Riwayat & Log Interaksi QC (Audit Trail)")
          ], -1)),
          _createElementVNode("span", _hoisted_86, _toDisplayString((_ctx.order.qc_histories && _ctx.order.qc_histories.length) || 0) + " Aktivitas ", 1)
        ]),
        _createElementVNode("div", _hoisted_87, [
          _createElementVNode("table", _hoisted_88, [
            _cache[60] || (_cache[60] = _createElementVNode("thead", { class: "table-light" }, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", {
                  scope: "col",
                  style: {"width":"15%"}
                }, "Waktu"),
                _createElementVNode("th", {
                  scope: "col",
                  style: {"width":"15%"}
                }, "Pengirim"),
                _createElementVNode("th", {
                  scope: "col",
                  style: {"width":"12%"}
                }, "Tujuan"),
                _createElementVNode("th", {
                  scope: "col",
                  style: {"width":"15%"}
                }, "Status & Run"),
                _createElementVNode("th", {
                  scope: "col",
                  style: {"width":"25%"}
                }, "Catatan / Pesan"),
                _createElementVNode("th", {
                  scope: "col",
                  style: {"width":"18%"}
                }, "Berkas & Aksi")
              ])
            ], -1)),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_ctx.order.qc_histories || []), (item) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: item.id
                }, [
                  _createElementVNode("td", _hoisted_89, _toDisplayString(_ctx.formatDateTime(item.created_at)), 1),
                  _createElementVNode("td", null, [
                    _createElementVNode("span", {
                      class: _normalizeClass(["badge", _ctx.senderBadgeClass(item.sender_type)])
                    }, _toDisplayString(item.sender_type), 3),
                    _createElementVNode("div", _hoisted_90, _toDisplayString(item.user?.name || item.customer?.name || (item.sender_type === 'PELANGGAN' ? _ctx.order.customer?.name : 'User')), 1)
                  ]),
                  _createElementVNode("td", null, [
                    _createElementVNode("span", {
                      class: _normalizeClass(["badge", _ctx.targetBadgeClass(item.target)])
                    }, " Ke " + _toDisplayString(_ctx.formatTarget(item.target)), 3)
                  ]),
                  _createElementVNode("td", null, [
                    _createElementVNode("span", {
                      class: _normalizeClass(["badge px-2 py-1 fs-11 mb-1 d-inline-block", _ctx.qcStatusBadgeClass(item.qc_status)])
                    }, _toDisplayString(item.qc_status || '-'), 3),
                    _createElementVNode("div", _hoisted_91, " Run ke-" + _toDisplayString(item.revision_run || 1), 1)
                  ]),
                  _createElementVNode("td", null, [
                    _createElementVNode("div", _hoisted_92, _toDisplayString(item.notes || '-'), 1)
                  ]),
                  _createElementVNode("td", null, [
                    (item.attachment_file)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_93, [
                          _createElementVNode("a", {
                            href: _ctx.getFileUrl(item.attachment_file),
                            target: "_blank",
                            class: "btn btn-xs btn-outline-secondary d-inline-flex align-items-center gap-1 text-truncate",
                            style: {"max-width":"200px"},
                            title: _ctx.getFilename(item.attachment_file)
                          }, [
                            _cache[57] || (_cache[57] = _createElementVNode("span", { class: "material-symbols-outlined fs-14" }, "attach_file", -1)),
                            _createElementVNode("span", _hoisted_95, _toDisplayString(_ctx.getFilename(item.attachment_file)), 1)
                          ], 8, _hoisted_94),
                          _createElementVNode("button", {
                            class: "btn btn-xs btn-outline-primary d-inline-flex align-items-center gap-1 fw-medium",
                            onClick: ($event: any) => (_ctx.setPrimaryFile(item.attachment_file)),
                            disabled: _ctx.settingPrimary,
                            title: "Gantikan naskah utama pesanan dengan berkas ini"
                          }, _cache[58] || (_cache[58] = [
                            _createElementVNode("span", { class: "material-symbols-outlined fs-14" }, "swap_horizontal_circle", -1),
                            _createElementVNode("span", null, "Jadikan File Utama untuk Diedit", -1)
                          ]), 8, _hoisted_96)
                        ]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_97, "-"))
                  ])
                ]))
              }), 128)),
              (!_ctx.order.qc_histories || _ctx.order.qc_histories.length === 0)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_98, _cache[59] || (_cache[59] = [
                    _createElementVNode("td", {
                      colspan: "6",
                      class: "text-center py-4 text-muted fs-12"
                    }, [
                      _createElementVNode("span", { class: "material-symbols-outlined fs-24 d-block mb-1 text-muted" }, "receipt_long"),
                      _createTextVNode(" Belum ada catatan riwayat QC pada pesanan ini. ")
                    ], -1)
                  ])))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ])
  ]))
}